import { Link } from "react-router-dom";
const HighLights = ({data}) => {
    const { img, title, heading, btn, url, text } = data;
    return <>
        <div className="img">
            <img className="w-[300px] md:[350px] lg:w-[380px] hover:rotate-[25deg] transition-all" src={img} alt="" />
        </div>
        <div className="flex flex-col items-center md:items-start pt-3">
            <h2 className="text-blue-700 text-center font-extrabold text-[20px] lg:text-[25px]">{heading}</h2>
            <h1 className="text-black font-extrabold text-[16px] lg:text-[20px]">{title}</h1>
            <p className="text-center text-[12px] lg:text-[16px] lg:leading-4 md:w-[320px] lg:w-[360px] md:text-start leading-3 text-slate-700">
                {text}
            </p>
            <Link className="mt-4" to={url}>
                <button className="text-white py-2 px-4 text-[14px] bg-slate-900 rounded-md">{btn}</button>
            </Link>
        </div>
    </>
}
export default HighLights